// extracted by mini-css-extract-plugin
module.exports = {"container":"IU-z","copyContainer":"JU-z","hidden":"KU-z"};